var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.305 12.852L6.35 7.816 1.275 2.667c-.502-.502-.413-.8.089-1.303.502-.502.823-.613 1.325-.11l5.07 5.144 5.045-5.077c.502-.502.786-.46 1.288.043.502.502.62.86.118 1.361L9.144 7.761l5.062 5.009c.502.502.388.82-.114 1.322-.502.502-.798.594-1.3.092L7.734 9.18l-5.077 5.024c-.502.502-.79.39-1.293-.112-.502-.502-.561-.738-.06-1.24z",
    opacity: 0.6,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3c0df791fdd40de77050a64fa575d755.svg";
export { ForwardRef as ReactComponent };